// 富文本展开/收起全局方法（供无水合内联 onclick 调用）
export default defineNuxtPlugin(() => {
  if (typeof window === 'undefined') return
  if ((window as any).__toggleRichText) return

  ;(window as any).__toggleRichText = (id: string) => {
    try {
      const content = document.getElementById(`rich-text-${id}`)
      if (!content) return

      const btn = document.querySelector(
        `.content-more[data-component-id="${id}"]`
      ) as HTMLElement | null

      const collapsedHeight = (content as HTMLElement).dataset?.collapsedHeight || '795'
      const expanded = btn?.getAttribute('data-expanded') === '1'

      if (!expanded) {
        content.style.height = 'auto'
        content.style.maxHeight = '100%'
        content.style.overflow = 'visible'
        if (btn) {
          btn.setAttribute('data-expanded', '1')
          btn.textContent = '收起'
        }
      } else {
        content.style.maxHeight = `${collapsedHeight}px`
        content.style.overflow = 'hidden'
        if (btn) {
          btn.setAttribute('data-expanded', '0')
          btn.textContent = '查看更多'
          content.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }
    } catch (err) {
      console.error('toggleRichText error', id, err)
    }
  }
})



